import { ColumnOrder } from '../utils/types/columnOrder';
import { ApiClient, ClientType } from './apiClient/ApiClient';
import { ServiceType } from './apiClient/config';

const apiClient = () => { return ApiClient.Client(ClientType.NotCached, ServiceType.Api); };

export const getColumnOrder = async (viewKey: string, clientId: string) => {
  const columnOrder = await apiClient().get<ColumnOrder>(`v2/portal-frame/viewConfiguration?viewKey=${viewKey}&clientId=${clientId}`);

  return columnOrder;
};

export const saveColumnOrder = async (columnOrder: ColumnOrder) => {
  const saveResponse = await apiClient().post("v2/portal-frame/viewConfiguration", columnOrder);

  return saveResponse;
};